/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// error message
import ErrorTemplate from 'pages/error/error_template/error_template';
// ctas
import Button from 'material/ctas/button/button_container';
// graphics
import Illustration from 'material/graphic/illustration/illustration';
// styles
// import injectSheet from 'react-jss';
// import styles from 'pages/error/404/404_styles';



/* ========== ~~~~~~~~~~ ERROR : 404 ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const error404 = (props) => {
    return(
        <ErrorTemplate 
            styles={'error404'}
            code={`404`}
            title={<h2>Page not found</h2>}
            bodycopy={<p>We're unable to find the page you're looking for. But don't worry you still can go to home or contact our team.</p>}
            button={<Button type={`custom`} handleClick={(e) => window.history.back()} variant={`primary`} name={`back`} text={`Back`} />}
            illustration={<Illustration name={`error-404`} text={`Error Illustration`} />}
        />
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default error404;
// export default injectSheet(styles)(error404);
